import api from './index'
import {
  axios,
  pureAxios,
  pyAxios
} from '@/utils/request'
import {
	downLoadXlxs,
	downLoadPdf,
	downLoadXlxs3
} from '@/utils/index'

//获取业务费列表
export function purchaseFee(parameter) {
  return axios({
    url: api.gateway_act + 'business_fee_apply/list/purchaseFee',
    method: 'get',
    params: parameter
  })
}

//获取业务费code
export function list_code(parameter) {
  return axios({
    url: api.gateway_act + 'business_fee_apply/code',
    method: 'get',
    params: parameter
  })
}

//新增业务费申请
export function apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'business_fee_apply/save',
    method: 'post',
    data: parameter
  })
}

//我的申请
export function list_my(parameter) {
  return axios({
    url: api.gateway_act + 'business/list/my',
    method: 'get',
    params: parameter
  })
}

//获取报销编号
export function apply_code(parameter) {
  return axios({
    url: api.gateway_act + 'reimburse_apply/code',
    method: 'get',
    params: parameter
  })
}

//获取关联审批单下拉列表
export function audit_list(parameter) {
  return axios({
    url: api.gateway_act + 'reimburse_apply/audit_list',
    method: 'get',
    params: parameter
  })
}

//获取审批付款编号
export function review_apply_code(parameter) {
  return axios({
    url: api.gateway_act + 'review_apply/code',
    method: 'get',
    params: parameter
  })
}
//获取审批付款编号2
export function cover_apply_code(parameter) {
  return axios({
    url: api.gateway_act + 'cover_apply/code',
    method: 'get',
    params: parameter
  })
}
//获取审批付款编号3
export function other_apply_code(parameter) {
  return axios({
    url: api.gateway_act + 'other_apply/code',
    method: 'get',
    params: parameter
  })
}

//获取需求反馈审批编号
export function feedback_code(parameter) {
  return axios({
    url: api.gateway_act + 'feedback/code',
    method: 'get',
    params: parameter
  })
}

//获取审批付款编号
export function review_apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'review_apply/save',
    method: 'post',
    data: parameter
  })
}
//获取审批付款编号2
export function cover_apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'cover_apply/save',
    method: 'post',
    data: parameter
  })
}
//获取审批付款编号3
export function other_apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'other_apply/save',
    method: 'post',
    data: parameter
  })
}

//新增申请
export function feedback_save(parameter) {
  return axios({
    url: api.gateway_act + 'feedback/save',
    method: 'post',
    data: parameter
  })
}


//获取审批付款编号
export function review_apply_list(parameter) {
  return axios({
    url: api.gateway_act + 'review_apply/list',
    method: 'get',
    params: parameter
  })
}

//查询服务费列表
export function cover_apply_list(parameter) {
  return axios({
    url: api.gateway_act + 'cover_apply/list',
    method: 'get',
    params: parameter
  })
}

//查询其他费用列表
export function other_apply_list(parameter) {
  return axios({
    url: api.gateway_act + 'other_apply/list',
    method: 'get',
    params: parameter
  })
}

//获取审批付款编号
export function reimburse_apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'reimburse_apply/save',
    method: 'post',
    data: parameter
  })
}


//获取付款编号
export function payment_apply_code(parameter) {
  return axios({
    url: api.gateway_act + 'payment_apply/code',
    method: 'get',
  })
}

// 新增申请付款
export function payment_apply_save(parameter) {
  return axios({
    url: api.gateway_act + 'payment_apply/save',
    method: 'post',
    data: parameter
  })
}

//获取付款详情
export function payment_apply_get(parameter) {
  return axios({
    url: api.gateway_act+'payment_apply/biz/'+parameter,
    method: 'get',
  })
}
//合同审批详情
export function contract_apply_get(parameter) {
  return axios({
    url: api.gateway_act+'contract_apply/biz/'+parameter,
    method: 'get',
  })
}

//获取查询合同审批编号
export function contract_apply_code(parameter) {
  return axios({
    url: api.gateway_act+'contract_apply/code',
    method: 'get',
  })
}

//查询合同审批列表
export function contract_apply_list(parameter) {
  return axios({
    url: api.gateway_act+'contract_apply/list',
    method: 'get',
    params:parameter
  })
}

//新增合同审批
export function contract_apply_save(parameter) {
  return axios({
    url: api.gateway_act+'contract_apply/save',
    method: 'post',
    data:parameter
  })
}
// 获取查询回款管理编号
export function pay_back_code(parameter) {
  return axios({
    url: api.gateway_act+'pay_back/code',
    method: 'get',
    params:parameter
  })
}
// 查询回款管理列表
export function pay_back_list(parameter) {
  return axios({
    url: api.gateway_act+'pay_back/list',
    method: 'get',
    params:parameter
  })
}
// 新增回款管理
export function pay_back_save(parameter) {
  return axios({
    url: api.gateway_act+'pay_back/save',
    method: 'post',
    data:parameter
  })
}
// 获取用印申请编号
export function seal_apply_code(parameter) {
  return axios({
    url: api.gateway_act+'seal_apply/code',
    method: 'get',
    params:parameter
  })
}
// 用印新增申请
export function seal_apply_save(parameter) {
  return axios({
    url: api.gateway_act+'seal_apply/save',
    method: 'post',
    data:parameter
  })
}
//获取用印详情
export function seal_apply_get(parameter) {
  return axios({
    url: api.gateway_act+'seal_apply/biz/'+parameter,
    method: 'get',
  })
}
// 获取通用审批编号
export function universal_apply_code(parameter) {
  return axios({
    url: api.gateway_act+'universal_apply/code',
    method: 'get',
    params:parameter
  })
}
// 获取薪资核准申请编号
export function salary_approval_code(parameter) {
  return axios({
    url: api.gateway_act+'salary_approval/code',
    method: 'get',
    params:parameter
  })
}
// 获取调薪申请编号
export function salary_adjustment_code(parameter) {
  return axios({
    url: api.gateway_act+'salary_adjustment/code',
    method: 'get',
    params:parameter
  })
}
// 通用新增申请
export function universal_apply_save(parameter) {
  return axios({
    url: api.gateway_act+'universal_apply/save',
    method: 'post',
    data:parameter
  })
}
// 调薪新增申请
export function salary_adjustment_save(parameter) {
  return axios({
    url: api.gateway_act+'salary_adjustment/save',
    method: 'post',
    data:parameter
  })
}
// 薪资新增申请
export function salary_approval_save(parameter) {
  return axios({
    url: api.gateway_act+'salary_approval/save',
    method: 'post',
    data:parameter
  })
}
//获取通用详情
export function universal_apply_get(parameter) {
  return axios({
    url: api.gateway_act+'universal_apply/biz/'+parameter,
    method: 'get',
  })
}
//获取需求反馈详情
export function feedback_get(parameter) {
  return axios({
    url: api.gateway_act+'feedback/biz/'+parameter,
    method: 'get',
  })
}
//获取薪资核准详情
export function salary_approval_get(parameter) {
  return axios({
    url: api.gateway_act+'salary_approval/biz/'+parameter,
    method: 'get',
  })
}
//获取调薪详情
export function salary_adjustment_get(parameter) {
  return axios({
    url: api.gateway_act+'salary_adjustment/biz/'+parameter,
    method: 'get',
  })
}
//获取通用详情
export function goods_rejected_info(parameter) {
  return axios({
    url: api.gateway_act+'goods_rejected/info/'+parameter,
    method: 'get',
  })
}


//财务2.0
// 获取目录
export function get_directoryList(parameter) {
  return axios({
    url: 'act/directoryList',
    method: 'get',
    params: parameter
  })
}
// 新增目录
export function add_directory(parameter) {
  return axios({
    url: '/act/directory',
    method: 'post',
    data: parameter
  })
}
// 删除目录
export function del_directory(parameter) {
  return axios({
    url: '/act/directory_delete',
    method: 'get',
    params: parameter
  })
}
// 更新目录
export function edit_directory(parameter) {
  return axios({
    url: '/act/directory',
    method: 'put',
    data: parameter
  })
}
// 查询模板列表
export function get_templatelist(parameter) {
  return axios({
    url: '/act/templatelist',
    method: 'get',
    params: parameter
  })
}
// 激活或者禁用
export function set_active(parameter) {
  return axios({
    url: '/act/active',
    method: 'get',
    params: parameter
  })
}
// 删除模板

export function del_template(parameter) {
  return axios({
    url: '/act/template_delete',
    method: 'get',
    params: parameter
  })
}
// 获取所有配置列表
export function get_confiig(parameter) {
  return axios({
    url: '/act/confiig',
    method: 'get',
    params: parameter
  })
}
// 新增模板
export function add_template(parameter) {
  return axios({
    url: '/act/template',
    method: 'post',
    data: parameter
  })
}
// 获取模板
export function get_template(parameter) {
  return axios({
    url: '/act/template',
    method: 'get',
    params: parameter
  })
}
// 更新维护模板
export function put_template(parameter) {
  return axios({
    url: '/act/template',
    method: 'PUT',
    data: parameter
  })
}
//表单提交
export function postApply(parameter) {
  return axios({
    url: '/act/start',
    method: 'post',
    data: parameter
  })
}
//获取流程详情
export function getPaymentApplyList(parameter) {
  return axios({
    url: '/act/getPaymentApplyList',
    method: 'get',
    params: parameter
  })
}
// 获取详情
export function getPaymentDetail(parameter) {
  return axios({
    url: '/act/biz/' + parameter,
    method: 'get',
    params: parameter
  })
}
//判断发票是否重复
export function checkDup(parameter) {
  return axios({
    url: '/act/checkDup',
    method: 'get',
    params: parameter
  })
}
//获取目录
export function directoryListAll(parameter) {
  return axios({
    url: '/act/directoryListAll',
    method: 'get',
    params: parameter
  })
}
//校验末班是否有权限
export function allowApply(parameter) {
  return axios({
    url: '/act/allowApply',
    method: 'get',
    params: parameter
  })
}
//获取模板
export function templateList(parameter) {
  return axios({
    url: '/act/template',
    method: 'get',
    params: parameter
  })
}
//获取全部审批单
export function getall(parameter) {
  return axios({
    url: '/act/getall',
    method: 'get',
    params: parameter
  })
}
//是否重新提交
export function isApply(parameter) {
  return axios({
    url: '/act/check/template/old',
    method: 'get',
    params: parameter
  })
}
//获取模板二级名称
export function getSecondDir(parameter) {
  return axios({
    url: '/act/secondDir',
    method: 'get',
    params: parameter
  })
}
//获取列表接口
export function getFinanceReimburseData(parameter) {
  return axios({
    url: '/act/payment_apply/getFinanceReimburseData',
    method: 'get',
    params: parameter
  })
}
//获取投标申请详情
export function bidDetail(parameter) {
  return axios({
    url:'/act/bid/detail/'+parameter,
    method: 'get',
  })
}
//导出换车补贴
export function subsidyApply(parameter) {
  return axios({
    url:'/act/biz_car_subsidy_apply/export',
    method: 'get',
    params: parameter
  })
}
//编辑弹窗提交
export function updateBizPersonalMoney(parameter) {
  return axios({
    url: '/act/payment_apply/updateBizPersonalMoney',
    method: 'post',
    data: parameter
  })
}
//查询项目信息
export function getProjectInfo(parameter) {
   return axios({
    url:'/act/ap/getProjectInfo',
    method: 'get',
    params: parameter
   })
  }

  export function userAll(parameter) {
    return axios({
     url:'/system/user/all',
     method: 'get',
     params: parameter
    })
   }
  //  1、获取列表接口：
  export function getFinanceReimburseDetailData(parameter) {
    return axios({
     url:'/act/payment_apply/getFinanceReimburseDetailData',
     method: 'get',
     params: parameter
    })
   }
  //  查看项目编号是否输入正确
  // project_amount_apply/projectInfo
  export function projectInfo(parameter){
    return axios({
      url:'/act/project_amount_apply/projectInfo',
      method:'get',
      params:parameter
    })
  }
 // 付款申请 新增 付款类别 基础信息 导出
 export function downTemplate(parameter){
  return downLoadXlxs(
    '/act/projectexcel/downTemplate',
    parameter
  )
}
// /act/projectexcel/importData
// 付款申请导入
export function importData(data){
  return axios({
    url: '/act/projectexcel/importData',
    method: 'post',
    data,
  })
}


